import React from "react"
import PropTypes from "prop-types"
import SanityImage from "gatsby-plugin-sanity-image"


const GatsbySanityImage = (props) => {
  const { width, image, ...rest } = props
  if (!props.image) return null
  return (
    <SanityImage  {...image}  {...rest} />
  )
}

GatsbySanityImage.defaultProps = {
  width: 2500,
}

GatsbySanityImage.propTypes = {
  image: PropTypes.object.isRequired,
}

export default GatsbySanityImage